import { render, staticRenderFns } from "./dataSourceModel.vue?vue&type=template&id=34d94fac"
import script from "./dataSourceModel.vue?vue&type=script&lang=js"
export * from "./dataSourceModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34d94fac')) {
      api.createRecord('34d94fac', component.options)
    } else {
      api.reload('34d94fac', component.options)
    }
    module.hot.accept("./dataSourceModel.vue?vue&type=template&id=34d94fac", function () {
      api.rerender('34d94fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/dataSourceManage/dataSourceModel.vue"
export default component.exports